import React, { useEffect, useMemo } from 'react';

import { observer } from 'mobx-react';
import { Spinner } from '@bringg/react-components';
import { PresetViewSupportedView } from '@bringg/types';

import { PresetViewsPicker } from './preset-views-picker';
import { presetViewsRoot } from '../stores/data-providers/preset-views-root';
import {
	getActivePresetViewForView,
	getPresetViewType,
	sendPresetViewsInitiatedEvent,
	sortByPresetScope
} from '../utils';

import styles from './preset-views-picker.module.scss';

export interface PresetViewsPickerContainer {
	path: string;
	className?: string;
}

export const PresetViewsPickerContainer = observer(function PresetViewsPickerContainer({
	path,
	className
}: PresetViewsPickerContainer) {
	const presetsViewType: PresetViewSupportedView = getPresetViewType(path);
	const activePreset = getActivePresetViewForView(presetsViewType);

	const {
		presetViewsViewStore: { allLoaded },
		presetViewStoreRepo
	} = presetViewsRoot.getStore();
	// todo: investigate how to proper use presetViewStoreRepo.getGroupByGroupKey here
	// presetViewStoreRepo.getGroupByGroupKey doesn't update itself correct when the entities changed/deleted in store
	const allPresetViews = presetViewStoreRepo.getAll();

	const presetViews = useMemo(() => {
		return allPresetViews.filter(preset => preset.view === presetsViewType).sort(sortByPresetScope);
	}, [allPresetViews, presetsViewType]);

	useEffect(() => {
		if (allLoaded) {
			// in case react store/component was started at first place
			// we need to send this event on component initialization to be sure
			// that the angular service handle this event and promises in the service was resolved
			// https://bringg.atlassian.net/browse/BRNGG-30245
			sendPresetViewsInitiatedEvent();
		}
	}, [allLoaded]);

	return (
		<div className={styles.presetViewPickerContainer}>
			{allLoaded ? (
				<PresetViewsPicker className={className} activePreset={activePreset} presetViews={presetViews} />
			) : (
				<Spinner size="small" />
			)}
		</div>
	);
});
